import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import es from './locales/es.json';
import de from './locales/de.json';

// Initialize i18next
const i18nConfig = {
  resources: {
    en: { translation: en },
    es: { translation: es },
    de: { translation: de }
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  },
  react: {
    useSuspense: false
  }
};

if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next)
    .init(i18nConfig);
}

export default i18n;